/*
 * VALIZ · campaña con cupón (snippets/valiz-campana-*.liquid).
 *  · Relojes [data-vc-reloj data-fin]: hh:mm:ss en [data-vc-cuenta] o en cajas [data-vc-h/m/s].
 *  · Todo lo que lleva [data-vc-fin] se quita solo al vencer (la tienda guarda páginas en caché).
 *  · [data-vc-copiar] copia el código.
 *  · [data-vc-activar] deja el cupón puesto (GET /discount/CÓDIGO, igual que un link con cupón).
 *  · [data-vc-aplicar] en el carro: pone el cupón en el carro (/cart/update.js con discount)
 *    y vuelve a dibujar el carro lateral.
 */
(function () {
  if (window.ValizCampana) return;
  window.ValizCampana = true;

  function dos(n) { return (n < 10 ? '0' : '') + n; }
  function todos(sel, raiz) { return Array.prototype.slice.call((raiz || document).querySelectorAll(sel)); }

  // ---------- Relojes y vencimiento ----------
  function tick() {
    var ahora = Date.now();
    todos('[data-vc-fin]').forEach(function (el) {
      var fin = parseInt(el.getAttribute('data-vc-fin'), 10) * 1000;
      // En el carrusel de portada lo quita su propio script (rearma los puntos).
      if (fin && ahora >= fin && !el.closest('[data-slide]')) el.remove();
    });
    todos('[data-vc-reloj]').forEach(function (r) {
      var resta = Math.max(0, Math.floor((parseInt(r.dataset.fin, 10) * 1000 - ahora) / 1000));
      var h = Math.floor(resta / 3600), m = Math.floor((resta % 3600) / 60), s = resta % 60;
      var c = r.querySelector('[data-vc-cuenta]');
      if (c) c.textContent = dos(h) + ':' + dos(m) + ':' + dos(s);
      var bh = r.querySelector('[data-vc-h]'), bm = r.querySelector('[data-vc-m]'), bs = r.querySelector('[data-vc-s]');
      if (bh) bh.textContent = dos(h);
      if (bm) bm.textContent = dos(m);
      if (bs) bs.textContent = dos(s);
    });
  }
  tick();
  setInterval(tick, 1000);

  // ---------- Cupón ya activado (cookie que deja /discount/CÓDIGO) ----------
  function codigoActivo() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    return m ? decodeURIComponent(m[1]).toUpperCase() : '';
  }
  function marcarActivado(codigo) {
    todos('[data-vc-activar]').forEach(function (b) {
      if (b.dataset.vcActivar !== codigo) return;
      b.textContent = '✓ Cupón activado';
      b.classList.add('is-activo');
      b.disabled = true;
      var caja = b.closest('[data-vc-codigo]');
      var nota = caja && caja.querySelector('[data-vc-nota]');
      if (nota && !nota.dataset.vcListo) {
        nota.dataset.vcListo = '1';
        nota.textContent = 'Listo: el descuento se aplica solo en el carro y al pagar.';
      }
    });
  }
  function revisarActivado() {
    var c = codigoActivo();
    if (c) marcarActivado(c);
  }
  revisarActivado();

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;

    var copiar = t.closest('[data-vc-copiar]');
    if (copiar) {
      e.preventDefault();
      var et = copiar.querySelector('[data-vc-copiar-texto]');
      var listo = function () { if (et) { et.textContent = '¡Copiado!'; setTimeout(function () { et.textContent = 'Copiar'; }, 2000); } };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(copiar.dataset.vcCopiar).then(listo, listo);
      else listo();
      return;
    }

    var activar = t.closest('[data-vc-activar]');
    if (activar && !activar.disabled) {
      e.preventDefault();
      var codigo = activar.dataset.vcActivar;
      activar.disabled = true;
      activar.textContent = 'Activando…';
      fetch('/discount/' + encodeURIComponent(codigo), { credentials: 'same-origin' })
        .then(function () { marcarActivado(codigo); })
        .catch(function () { activar.disabled = false; activar.textContent = 'Activar cupón'; });
      return;
    }

    var aplicar = t.closest('[data-vc-aplicar]');
    if (aplicar && !aplicar.disabled) {
      e.preventDefault();
      aplicarEnCarro(aplicar);
    }
  });

  // ---------- Carro ----------
  function aplicarEnCarro(boton) {
    var codigo = boton.dataset.vcAplicar;
    var caja = boton.closest('[data-vc-carro]');
    var error = caja && caja.querySelector('[data-vc-error]');
    var drawer = document.querySelector('cart-drawer');
    boton.disabled = true;
    boton.textContent = 'Aplicando…';
    if (error) error.hidden = true;
    var cuerpo = { discount: codigo };
    if (drawer) cuerpo.sections = 'cart-drawer,cart-icon-bubble';
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(cuerpo),
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, datos: j }; }); })
      .then(function (r) {
        if (!r.ok) throw new Error((r.datos && (r.datos.description || r.datos.message)) || 'No se pudo aplicar');
        // Además deja la cookie, por si el pago se abre desde otra pestaña.
        fetch('/discount/' + encodeURIComponent(codigo), { credentials: 'same-origin' });
        if (drawer && r.datos.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents({ id: null, sections: r.datos.sections });
        } else {
          window.location.reload();
        }
      })
      .catch(function (err) {
        boton.disabled = false;
        boton.textContent = 'Aplicar';
        if (error) { error.textContent = err.message; error.hidden = false; }
      });
  }

  // El tema solo vuelve a dibujar los productos y el pie del carro al cambiar
  // cantidades; esta caja queda fuera, así que se refresca aparte.
  function refrescarCaja() {
    var actual = document.querySelector('cart-drawer [data-vc-carro]');
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    fetch('/?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j && j['cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var nueva = tmp.querySelector('[data-vc-carro]');
        actual = document.querySelector('cart-drawer [data-vc-carro]');
        if (actual && nueva) actual.replaceWith(nueva);
        else if (actual && !nueva) actual.remove();
        else if (!actual && nueva) {
          var ancla = drawer.querySelector('.drawer__header');
          if (ancla) ancla.insertAdjacentElement('afterend', nueva);
        }
        tick();
      })
      .catch(function () {});
  }
  function suscribir() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
      if (ev && ev.source === 'valiz-campana') return;
      setTimeout(refrescarCaja, 250);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', suscribir);
  else suscribir();
})();
